import axios from 'axios';
import store from '../store/store';
import { AuthReducer } from '../redux/auth';
import { updateRefreshToken } from 'pages/auth-pages/utils';
import { encryptApiData, decryptApiData } from '../config/security';
import { SKIP_ENCRYPT } from '../config/config';
const AuthActions = AuthReducer.actions;

// Routes whose response is encrypted with the client's local public key (and so
// decrypted with our local private key). Everything else is decrypted with the
// serverPrivateKey handed back at login. Mirrors midani-frontend's publicApisList.
const publicApisList = ['admin-users/login'];

const isStartup = (url) => url === 'startup' || url.endsWith('/startup');
const isPublicApi = (url) => publicApisList.some((p) => url === p || url.endsWith('/' + p));

axios.interceptors.request.use(
  async function (config) {
    let apiPath = process.env.REACT_APP_API_PATH;
    let url = config.url;
    let auth = store.getState().auth;

    let isRetry = config._retry;

    let tokenType = config.headers.token_type;
    if (!isRetry) {
      config.url = apiPath + '/' + url;
    } else {
      tokenType = config.headers['token-type'];
    }

    let authToken =
      tokenType === 'staticToken'
        ? process.env.REACT_APP_STATIC_TOKEN
        : tokenType === 'refresh'
        ? auth.accessRefreshToken
        : auth.accessToken;
    let headers = {
      'content-type': 'application/json',
      Authorization: 'Bearer ' + authToken,
      skipencrypt: SKIP_ENCRYPT,
    };
    config.headers = headers;

    // Encrypt the outgoing payload (except the startup handshake, and except a
    // 401 retry whose body is already encrypted from the first attempt).
    if (!isStartup(url) && !isRetry) {
      const security = store.getState().security;
      const requestData = isPublicApi(url)
        ? { ...config.data, publicKey: security.localPublicKey }
        : config.data;
      if (!SKIP_ENCRYPT) {
        if (requestData) {
          const encryptedData = await encryptApiData(security.serverPublicKey, requestData);
          config.data = encryptedData;
        }
      } else {
        config.data = requestData;
      }
    }
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  },
);

axios.interceptors.response.use(
  async function (response) {
    // RETURN SUCCESS RESPONSE
    if (response.status === 200 || response.status === 201) {
      const url = response.config.url;
      // The startup handshake body is decrypted by handShakeFunc — hand it back raw.
      if (isStartup(url)) {
        return response.data;
      }
      try {
        if (!SKIP_ENCRYPT) {
          const security = store.getState().security;
          const decryptedData = await decryptApiData(
            isPublicApi(url) ? security.localPrivateKey : security.serverPrivateKey,
            response.data,
          );
          return { data: decryptedData.data, error: '' };
        }
        return { data: response.data.data, error: '' };
      } catch (err) {
        console.error('Error decrypting response data:', err);
        return { data: {}, error: 'Error decrypting response data' };
      }
    } else {
      // RETURN ERROR RESPONSE
      return { data: {}, error: response.error.msg };
    }
  },
  async function (error) {
    if (error.response && error.response.status === 401) {
      let originalRequest = error.config;
      if (!originalRequest._retry) {
        console.log('Refresh');
        await updateRefreshToken();
        originalRequest._retry = true;
        return new Promise((resolve) => {
          resolve(axios(originalRequest));
        });
      } else {
        store.dispatch(
          AuthActions.updateAuthState({ accessToken: null, accessRefreshToken: null }),
        );
        window.location.href = '/login';
      }
    } else {
      return {
        data: {},
        // error: error.msg,
        error: error.response.data.error.msg ?? error.response.data.error,
      };
    }
    console.log('ERROR', error.response.data.error);
    return {
      data: {},
      error: error.response.data.error.msg ?? error.response.data.error,
      // error: 'error',
    };
    // return Promise.reject(error);
  },
);
